// ============================================================
// Conversión y presentación de montos entre las tres monedas del
// sistema. Vive acá (y no dentro de una pantalla) porque lo usan el
// estado de cuenta y el formulario de factura por igual.
// ============================================================

export const MONEDA_LABEL = { USD: 'USD', BCV: 'BCV', BS: 'Bs' };

const npos = (n) => (Number(n) > 0 ? Number(n) : null);

// Prefijo de moneda para mostrar un monto según su forma/moneda.
// "BCV" y "USD" son ambos dólares, pero a distinta tasa: se marcan
// distinto para que un monto BCV nunca se lea como dólar real.
export function pref(moneda) {
  if (moneda === 'BS') return 'Bs ';
  if (moneda === 'BCV') return 'BCV$ ';
  return '$';
}

// Un valor `v` expresado en `moneda` -> a la vista pedida (USD/BCV/BS).
// El puente es el bolívar. Devuelve v sin convertir si falta la tasa.
export function aVista(v, vista, moneda, bcv, mercado) {
  const x = Number(v) || 0;
  if (vista === moneda) return x;
  const b = npos(bcv);
  const m = npos(mercado);
  let bs;
  if (moneda === 'BS') bs = x;
  else if (moneda === 'USD') { if (!m) return x; bs = x * m; }
  else { if (!b) return x; bs = x * b; }
  if (vista === 'BS') return bs;
  if (vista === 'USD') return m ? bs / m : x;
  if (vista === 'BCV') return b ? bs / b : x;
  return x;
}
